module.exports = __webpack_public_path__ + "static/media/live18_06_2022.91664be6.jpeg";